import { render, staticRenderFns } from "./loading-trip-info.vue?vue&type=template&id=491ee984&scoped=true&"
import script from "./loading-trip-info.vue?vue&type=script&lang=js&"
export * from "./loading-trip-info.vue?vue&type=script&lang=js&"
import style0 from "./loading-trip-info.vue?vue&type=style&index=0&id=491ee984&lang=scss&scoped=true&"
import style1 from "./loading-trip-info.vue?vue&type=style&index=1&id=491ee984&lang=scss&scoped=true&"
import style2 from "./loading-trip-info.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ee984",
  null
  
)

export default component.exports
import {QSkeleton,QAvatar,QTimeline,QTimelineEntry,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton,QAvatar,QTimeline,QTimelineEntry,QSeparator})
